import { render, staticRenderFns } from "./StuDetail.vue?vue&type=template&id=2c3a7082"
import script from "./StuDetail.vue?vue&type=script&lang=js"
export * from "./StuDetail.vue?vue&type=script&lang=js"
import style0 from "./StuDetail.vue?vue&type=style&index=0&id=2c3a7082&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports